<div>
    <!-- infos de la règle -->
    <ul class="flexList">

        <li *ngIf="isDialog">
            <span>Libellé de la règle</span>
            <span>{{rule.Libelle}}</span>
        </li>

        <li *ngIf="!isInteractivity && rule.IsTransverse">Règle d'interactivité</li>

        <li *ngIf="rule.IsComplementaire && isInteractivity" class="verif checked">
            <span>Enveloppe complémentaire</span>
        </li>
        <li *ngIf="rule.IsForcageAutorise" class="verif checked">
            <span>Autoriser le forçage</span>
        </li>
        <li *ngIf="rule.IsVenteSansSubAutorise" class="verif checked">
            <span>Autoriser la vente sans subvention</span>
        </li>

        <ng-container *ngIf="!isMediaOrResourcesActivity">
            <li *ngIf="rule.TypeRegle === ruleTypeEnum.QuotaNombre"><span>Quota défini</span> en nombre</li>
            <li *ngIf="rule.TypeRegle === ruleTypeEnum.QuotaFaciale"><span>Quota défini</span> en valeur faciale</li>
        </ng-container>

        <ng-container *ngIf="shouldShowSubventionType">
            <ng-container
                *ngIf="complementarySubvention.IsSubventionEnveloppeComplementaire; else notComplementaryTemplate">
                <li>{{'' + activityType | i18nSelect: subventionLabeli18nSelect }} <span>Complémentaire</span></li>

                <li *ngIf="complementarySubvention.IdEnveloppeComplementaire">
                    <span>{{ (complementarySubvention.IdEnveloppeComplementaire | findInListById: envelopes)?.Libelle }}</span>
                </li>
                <li *ngIf="complementarySubvention.Ordre">
                    <span>Ordre</span>
                    <span>{{complementarySubvention.Ordre}}</span>
                </li>
            </ng-container>
            <ng-template #notComplementaryTemplate>
                <li>
                    <span>{{'' + activityType | i18nSelect: subventionLabeli18nSelect }}</span>
                </li>
            </ng-template>
        </ng-container>
    </ul>

    <!-- insérer lien pour la pop-up dans règle interactivité ou le tableau -->
    <ng-content></ng-content>

    <!-- Arrondis -->
    <ul *ngIf="isNotAccessibilityRule && roundingType" class="flexList">
        <li>
            <span>Arrondi</span>
            <span>{{roundingType.TypeSP | i18nSelect: {
                S: isSavings ? 'abondement' : 'subvention',
                P: 'prix final'
            } }}</span>
        </li>
        <li><span>Type d'arrondi</span>
            <span>{{roundingType.TypeArrondi | i18nSelect : roundingI18nSelect }}</span>
        </li>
        <li><span>Précision</span>
            <span>{{roundingType.Valeur}}</span>
        </li>
    </ul>

</div>

